module.exports = __webpack_public_path__ + "media/images/index/feature/top-coj-c-3d9ea6417b9e2f5f30bc16f38e18a114.png";